import { render, staticRenderFns } from "./OpportunityDetails.vue?vue&type=template&id=2ea54225&scoped=true&"
import script from "./OpportunityDetails.vue?vue&type=script&lang=js&"
export * from "./OpportunityDetails.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OpportunityDetails.vue?vue&type=style&index=1&id=2ea54225&scoped=true&lang=css&"
import style2 from "./OpportunityDetails.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea54225",
  null
  
)

export default component.exports